import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c8f8f7a0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=c8f8f7a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f8f7a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8f8f7a0')) {
      api.createRecord('c8f8f7a0', component.options)
    } else {
      api.reload('c8f8f7a0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c8f8f7a0&scoped=true&", function () {
      api.rerender('c8f8f7a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/homeArticle/index.vue"
export default component.exports